<template>
    <div class="availabilities-campsite-and-date-filter column is-12">
        <div class="columns first-columns">
            <div class="column is-5">
                <label for="campsite-select">{{ $t('availabilities.detail.campsite') }}</label>
            </div>
            <div class="column is-5">
                <label>{{ $t('availabilities.detail.date') }}</label>
            </div>
        </div>
        <div class="columns">
            <div class="column is-5">
                <span class="select campsite-select-arrow">
                    <select id="campsite-select" v-model="selectedCampsiteId" name="campsite" @change="campsiteSelected()">
                        <option v-for="campsite of campsites" :value="campsite.id">
                            {{ campsite.name }}
                        </option>
                    </select>
                </span>
            </div>
            <div class="column is-4">
                <maxcamping-datepicker
                    class="date-picker"
                    v-model="selectedDates"
                    :config="pickerConfig"
                    :open="datePickerOpen"
                    @toggle-open="onDatePickerOpenRequest"
                />
            </div>
        </div>
    </div>
</template>

<script>
    import { Tracking } from '../../../utils';
    import MaxcampingDatepicker from '../../../vendors/vue-datepicker/ci-datepicker';
    import moment from 'moment';

    export default {
        name: 'availabilities-campsite-and-date-filter',

        props: {
            value: {
                type: [Number, String],
                'default': 0,
            },
            campsiteId: {
                type: [Number, String],
                'default': () => (null),
            },
            campsites: {
                type: Array,
                'default': () => ([]),
            },
            month: {
                type: Date,
                'default': () => (null),
            },
            trackName: {
                type: String,
                'default': () => ('AvailabilitiesByCampsite'),
            },
        },

        components: {
            MaxcampingDatepicker,
        },

        data() {
            let selectedDates = null;
            let lastSelectedDates = null;
            if(this.month) {
                selectedDates = [
                    new Date(this.month.getFullYear(), this.month.getMonth(), 1),
                    new Date(this.month.getFullYear(), this.month.getMonth() + 1, 0),
                ];
                lastSelectedDates = [
                    new Date(this.month.getFullYear(), this.month.getMonth(), 1),
                    new Date(this.month.getFullYear(), this.month.getMonth() + 1, 0),
                ];
            }
            return {
                selectedDates: selectedDates,
                lastSelectedDates: lastSelectedDates,
                lastSelectedCampsiteId: null,
                selectedCampsiteId: null,
                datePickerOpen: false,
                stopEmitting: false,
                pickerConfig: {
                    align: 'right',
                    mobileAlign: 'center',
                    displayMonths: 3,
                    range: false,
                    selectStyle: 'month',
                    initialDate: null,
                    minDate: new Date(new Date().getFullYear() - 1, 0, 1),
                    maxDate: new Date(new Date().getFullYear() + 3, 11, 31),
                    openTopOffset: 2,
                    showTooltip: false,
                    dateFormat: this.$t('generic.calendar.monthformat'),
                    dateFormatUseRange: false,
                    i18n: {
                        months: this.$t('generic.calendar.monthnames.long'),
                        weekdays: this.$t('generic.calendar.weeknames.short'),
                    },
                    placeholder: 'Monat...',
                },
            };
        },

        created() {
            this.selectedCampsiteId = this.campsiteId;
        },

        computed: {
            jumpDate() {
                if(!this.selectedDates || !this.selectedDates[0]) {
                    return null;
                }

                if(window.innerWidth <= 768) {
                    return this.selectedDates[0];
                }
                return new Date(this.selectedDates[0].getFullYear(), this.selectedDates[0].getMonth() - 1, 1);
            }
        },

        methods: {
            campsiteSelected() {
                Tracking.trackEvent(this.trackName, 'campsiteSelectboxClicked');
                let params = this.$route.params;
                let query = this.$route.query;
                if(this.$route.params.campsiteId !== undefined) {
                    params = {campsiteId: this.selectedCampsiteId};
                } else {
                    query['campsite'] = this.selectedCampsiteId;
                }
                this.$emit('route-request', {
                    route: {name: this.$route.name, params: params, query: query},
                    cancelCallback: () => {
                        this.selectedCampsiteId = this.lastSelectedCampsiteId;
                    },
                });
            },
            onDatePickerOpenRequest(open) {
                if(this.datePickerOpen === open) {
                    return;
                }
                this.datePickerOpen = open;
                const what = open ? 'Opened' : 'Closed';
                Tracking.trackEvent(this.trackName, `campsiteSelectbox${what}`);
            },
        },

        watch: {
            selectedDates(newVal, oldVal) {
                console.log(newVal);
                console.log(oldVal);
                this.lastSelectedDates = oldVal;
                this.datePickerOpen = false;
                if(this.stopEmitting) {
                    this.stopEmitting = false;
                    return;
                }
                Tracking.trackEvent(this.trackName, 'monthChooserMonthSelected', moment(newVal[0]).format('YYYY-MM'));
                this.$emit('route-request', {
                    route: {name: this.$route.name, params: this.$route.params, query: {date_from: moment(newVal[0]).format('YYYY-MM-DD'), date_until: moment(newVal[1]).format('YYYY-MM-DD')}},
                    cancelCallback: () => {
                        this.stopEmitting = true;
                        if(this.lastSelectedDates) {
                            this.selectedDates = [
                                new Date(this.lastSelectedDates[0].getFullYear(), this.lastSelectedDates[0].getMonth(), this.lastSelectedDates[0].getDate()),
                                new Date(this.lastSelectedDates[1].getFullYear(), this.lastSelectedDates[1].getMonth(), this.lastSelectedDates[1].getDate()),
                            ];
                        }
                    },
                });
            },

            selectedCampsiteId(newVal, oldVal) {
                this.lastSelectedCampsiteId = oldVal;
            },
        },
    };
</script>

<style lang="scss">
    @import './availabilities-campsite-and-date-filter.scss';
</style>



// WEBPACK FOOTER //
// src/views/components/availabilities/availabilities-campsite-and-date-filter.vue